<template>
  <div class="no_data_area">
    <div class="no_data"></div>
    <div class="no_text">
      <span>{{ text }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    text: {
      type: String,
      default: '暂无相关数据',
    },
  },
};
</script>

<style lang="less" scoped>
.no_data_area {
  color: #999;
  font-size: 14px;
  width: 100%;
  text-align: center;
  position: fixed;
  top: 32%;
  left: 0;
  right: 0;
  opacity: 0;
  animation: fadeIn 0.5s 1 forwards 0.1s;
  /* margin-top: 50px; */
}
.no_data_area .no_data {
  width: 160px;
  height: 178px;
  background-image: url("~@/assets/img/no_order.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0 auto 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/NoData.vue